export default class InlineVideo {
    constructor() {
        this.inlineVideos = document.querySelectorAll('.inline-video');
        this.init();
    }

    init() {
        if (!this.inlineVideos.length) return;

        this.inlineVideos.forEach((container) => {
            if (!container.classList.contains('inline-video-with-image')) return;

            const video = container.querySelector('video');
            const image = container.querySelector('img');

            if (!video || !image) return;

            this.waitForVideo(video, () => {
                image.style.display = 'none';
            });
        });
    }

    waitForVideo(video, callback) {
        // If the video is already far enough along, act immediately
        if (video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
            callback();
            return;
        }

        const onCanPlay = () => {
            video.removeEventListener('canplay', onCanPlay);
            callback();
        };

        video.addEventListener('canplay', onCanPlay);
    }
}
